import { useAppConfig } from '~/App/Api/AppConfig';

export function useAiEnrichment(): boolean {
  const { data: appConfig } = useAppConfig();
  return appConfig?.team?.ai_enrichment_enabled ?? true;
}
